'use client';

import { useDarkMode } from '@/lib/platform/contexts/dark-mode-context';

export default function NotFound() {
  const { darkMode } = useDarkMode();

  return (
    <div
      className={darkMode ? 'bg-gray-900' : 'bg-gray-50'}
      style={{
        margin: '-1.25rem -1rem',
        padding: 0,
        minHeight: 'calc(100vh - 4rem + 2.25rem)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          textAlign: 'center',
          color: darkMode ? '#fff' : '#000',
        }}
      >
        <h1
          style={{
            display: 'inline-block',
            margin: '0 20px 0 0',
            padding: '0 23px 0 0',
            fontSize: '24px',
            fontWeight: 500,
            verticalAlign: 'top',
            lineHeight: '49px',
            borderRight: darkMode
              ? '1px solid rgba(255, 255, 255, .3)'
              : '1px solid rgba(0, 0, 0, .3)',
          }}
        >
          404
        </h1>
        <div style={{ display: 'inline-block' }}>
          <h2
            style={{
              fontSize: '14px',
              fontWeight: 400,
              lineHeight: '49px',
              margin: 0,
            }}
          >
            This page could not be found.
          </h2>
        </div>
      </div>
    </div>
  );
}
